import React from 'react';
import { ArrowRight, Bot, Store, ShoppingBag, Zap, Shield, MessageSquare, Sparkles } from 'lucide-react';

// Mobile-optimised UCP Flow - Compact horizontal design
export const UCPFlowDiagram = () => {
  return (
    <div className="w-full">
      {/* Desktop Flow - Hidden on mobile */}
      <div className="hidden md:block">
        <div className="flex items-center justify-between gap-4 mb-12">
          {/* Customer with AI */}
          <div className="flex flex-col items-center text-center flex-1">
            <div className="w-20 h-20 rounded-2xl bg-[#f5f5f0]/10 border border-[#f5f5f0]/20 flex items-center justify-center mb-4">
              <Bot className="w-10 h-10 text-[#f5f5f0]/80" />
            </div>
            <h4 className="font-medium text-[#f5f5f0] mb-1">AI Agent</h4>
            <p className="text-xs text-[#f5f5f0]/50 max-w-[140px]">
              Customer asks Gemini, ChatGPT, or Copilot
            </p>
          </div>

          {/* Arrow */}
          <div className="flex items-center">
            <div className="w-12 h-px bg-gradient-to-r from-[#f5f5f0]/20 to-[#f5f5f0]/40"></div>
            <ArrowRight className="w-5 h-5 text-[#f5f5f0]/40" />
          </div>

          {/* UCP Protocol */}
          <div className="flex flex-col items-center text-center flex-1">
            <div className="w-24 h-24 rounded-2xl bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center mb-4 relative">
              <Zap className="w-12 h-12 text-emerald-400" />
              <div className="absolute -top-2 -right-2 w-6 h-6 bg-emerald-500 rounded-full flex items-center justify-center">
                <span className="text-[10px] font-bold text-white">UCP</span>
              </div>
            </div>
            <h4 className="font-medium text-emerald-400 mb-1">Universal Commerce Protocol</h4>
            <p className="text-xs text-[#f5f5f0]/50 max-w-[160px]">
              Open standard for AI-to-merchant communication
            </p>
          </div>

          {/* Arrow */}
          <div className="flex items-center">
            <div className="w-12 h-px bg-gradient-to-r from-[#f5f5f0]/40 to-[#f5f5f0]/20"></div>
            <ArrowRight className="w-5 h-5 text-[#f5f5f0]/40" />
          </div>

          {/* Your Store */}
          <div className="flex flex-col items-center text-center flex-1">
            <div className="w-20 h-20 rounded-2xl bg-[#f5f5f0]/10 border border-[#f5f5f0]/20 flex items-center justify-center mb-4">
              <Store className="w-10 h-10 text-[#f5f5f0]/80" />
            </div>
            <h4 className="font-medium text-[#f5f5f0] mb-1">Your Store</h4>
            <p className="text-xs text-[#f5f5f0]/50 max-w-[140px]">
              Products, pricing, and policies
            </p>
          </div>

          {/* Arrow */}
          <div className="flex items-center">
            <div className="w-12 h-px bg-gradient-to-r from-[#f5f5f0]/20 to-[#f5f5f0]/40"></div>
            <ArrowRight className="w-5 h-5 text-[#f5f5f0]/40" />
          </div>

          {/* Transaction */}
          <div className="flex flex-col items-center text-center flex-1">
            <div className="w-20 h-20 rounded-2xl bg-[#f5f5f0]/10 border border-[#f5f5f0]/20 flex items-center justify-center mb-4">
              <ShoppingBag className="w-10 h-10 text-[#f5f5f0]/80" />
            </div>
            <h4 className="font-medium text-[#f5f5f0] mb-1">Transaction</h4>
            <p className="text-xs text-[#f5f5f0]/50 max-w-[140px]">
              Seamless checkout without leaving AI
            </p>
          </div>
        </div>
      </div>

      {/* Mobile Flow - Compact horizontal strip */}
      <div className="md:hidden mb-8">
        <div className="flex items-center justify-between bg-[#0a0a0a] rounded-xl p-4 border border-white/5">
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 rounded-xl bg-[#f5f5f0]/10 flex items-center justify-center mb-2">
              <Bot className="w-6 h-6 text-[#f5f5f0]/80" />
            </div>
            <span className="text-[10px] text-[#f5f5f0]/50">AI Agent</span>
          </div>
          
          <ArrowRight className="w-4 h-4 text-[#f5f5f0]/30" />
          
          <div className="flex flex-col items-center">
            <div className="w-14 h-14 rounded-xl bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center mb-2">
              <Zap className="w-7 h-7 text-emerald-400" />
            </div>
            <span className="text-[10px] text-emerald-400 font-medium">UCP</span>
          </div>
          
          <ArrowRight className="w-4 h-4 text-[#f5f5f0]/30" />
          
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 rounded-xl bg-[#f5f5f0]/10 flex items-center justify-center mb-2">
              <Store className="w-6 h-6 text-[#f5f5f0]/80" />
            </div>
            <span className="text-[10px] text-[#f5f5f0]/50">Your Store</span>
          </div>
          
          <ArrowRight className="w-4 h-4 text-[#f5f5f0]/30" />
          
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 rounded-xl bg-[#f5f5f0]/10 flex items-center justify-center mb-2">
              <ShoppingBag className="w-6 h-6 text-[#f5f5f0]/80" />
            </div>
            <span className="text-[10px] text-[#f5f5f0]/50">Sale</span>
          </div>
        </div>
        
        {/* Mobile description */}
        <p className="text-center text-xs text-[#f5f5f0]/40 mt-4">
          AI agents discover, negotiate, and transact—all programmatically through UCP
        </p>
      </div>

      {/* Capabilities - Responsive grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
        <div className="bg-[#0a0a0a] rounded-xl p-4 md:p-5 border border-white/5">
          <div className="flex items-center gap-3 mb-2 md:mb-3">
            <div className="w-8 h-8 rounded-lg bg-emerald-500/10 flex items-center justify-center">
              <MessageSquare className="w-4 h-4 text-emerald-400" />
            </div>
            <h5 className="font-medium text-sm">Discovery</h5>
          </div>
          <p className="text-xs text-[#f5f5f0]/50">
            AI agents find your products through structured data and UCP profiles
          </p>
        </div>

        <div className="bg-[#0a0a0a] rounded-xl p-4 md:p-5 border border-white/5">
          <div className="flex items-center gap-3 mb-2 md:mb-3">
            <div className="w-8 h-8 rounded-lg bg-amber-500/10 flex items-center justify-center">
              <Sparkles className="w-4 h-4 text-amber-400" />
            </div>
            <h5 className="font-medium text-sm">Negotiation</h5>
          </div>
          <p className="text-xs text-[#f5f5f0]/50">
            Custom extensions enable loyalty, bundles, quizzes, and consultative selling
          </p>
        </div>

        <div className="bg-[#0a0a0a] rounded-xl p-4 md:p-5 border border-white/5">
          <div className="flex items-center gap-3 mb-2 md:mb-3">
            <div className="w-8 h-8 rounded-lg bg-blue-500/10 flex items-center justify-center">
              <Shield className="w-4 h-4 text-blue-400" />
            </div>
            <h5 className="font-medium text-sm">Checkout</h5>
          </div>
          <p className="text-xs text-[#f5f5f0]/50">
            Secure, embedded transactions with guaranteed landed costs
          </p>
        </div>
      </div>
    </div>
  );
};

// Simple comparison: Without UCP vs With UCP
export const UCPComparisonDiagram = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
      {/* Without UCP */}
      <div className="bg-[#0a0a0a] rounded-xl md:rounded-2xl p-5 md:p-6 border border-orange-500/20">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-2 h-2 rounded-full bg-orange-400"></div>
          <span className="text-sm font-medium text-orange-400">Without UCP</span>
        </div>
        <div className="space-y-2 md:space-y-3">
          <div className="flex items-center gap-3 text-sm text-[#f5f5f0]/50">
            <span className="text-orange-400">✗</span>
            <span>AI cannot read your product data</span>
          </div>
          <div className="flex items-center gap-3 text-sm text-[#f5f5f0]/50">
            <span className="text-orange-400">✗</span>
            <span>Invisible to agentic search</span>
          </div>
          <div className="flex items-center gap-3 text-sm text-[#f5f5f0]/50">
            <span className="text-orange-400">✗</span>
            <span>Competitors become the default answer</span>
          </div>
          <div className="flex items-center gap-3 text-sm text-[#f5f5f0]/50">
            <span className="text-orange-400">✗</span>
            <span>No brand control in AI conversations</span>
          </div>
        </div>
      </div>

      {/* With UCP */}
      <div className="bg-[#0a0a0a] rounded-xl md:rounded-2xl p-5 md:p-6 border border-emerald-500/20">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-2 h-2 rounded-full bg-emerald-400"></div>
          <span className="text-sm font-medium text-emerald-400">With UCP</span>
        </div>
        <div className="space-y-2 md:space-y-3">
          <div className="flex items-center gap-3 text-sm text-[#f5f5f0]/50">
            <span className="text-emerald-400">✓</span>
            <span>100% discoverable by AI agents</span>
          </div>
          <div className="flex items-center gap-3 text-sm text-[#f5f5f0]/50">
            <span className="text-emerald-400">✓</span>
            <span>Your brand is the definitive answer</span>
          </div>
          <div className="flex items-center gap-3 text-sm text-[#f5f5f0]/50">
            <span className="text-emerald-400">✓</span>
            <span>Embedded checkout without friction</span>
          </div>
          <div className="flex items-center gap-3 text-sm text-[#f5f5f0]/50">
            <span className="text-emerald-400">✓</span>
            <span>Full brand control via custom extensions</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UCPFlowDiagram;
